module.exports = __webpack_public_path__ + "static/media/ill-basic@2x.dd2fc06e.png";